import React from "react";
import Button from "../../_components/button/Button";

const Locator = () => {
  const handleClick = () => {
    window.open("https://www.anthemav.com/locator/index.php", "_blank");
  };
  return (
    <section className="z-50 relative" id="dealer_locator">
      {/* <div
        data-type="horizontal"
        className="py-12 px-5 md:py-20 lg:py-12 sm:py-0 bg-no-repeat bg-cover lg:h-screen"
        style={{
          backgroundImage:
            "url(" +
            "https://cdn.pmlsound.com/anthem/avm90/images/avm-90-dealer-locator-image.jpeg" +
            ")",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-6xl mx-auto">
          <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center  text-gray-900 leading-snug z-50 lg:mt-16 pb-16">
            Find your local <br />
            Authorized Anthem dealer
          </h4>

          <p className="text-xl  font-light text-center  mt-10">
            <Button
              name={"Learn more"}
              dark={true}
              centered={false}
              width={"fit"}
              handleClick={handleClick}
            />
          </p>
        </div>
      </div> */}

      <div className="absolute z-30 flex  justify-center items-center  overflow-hidden py-0 px-6 md:py-20 w-full">
        <div className="relative w-full  max-w-5xl mx-auto text-white ">
          <div className="max-w-6xl mx-auto">
            <h4 className="text-2xl md:text-5xl lg:text-6xl font-bold text-center  text-gray-900 leading-snug z-50 lg:mt-16 sm:pb-6">
              Find your local <br />
              Authorized Anthem dealer
            </h4>

            <p className="text-xl  font-light text-center  mt-10">
              <Button
                name={"Learn more"}
                dark={true}
                centered={false}
                width={"fit"}
                handleClick={handleClick}
              />
            </p>
          </div>
        </div>
      </div>
      <video
        id="videoMachine"
        width="100%"
        autoPlay
        // loop
        muted
        playsInline
        className=" z-0 w-full "
        style={
          {
            // filter: "blur(1px)",
            // objectFit: "cover",
            // transform: "scale(1.06)",
          }
        }
      >
        <source
          src="https://cdn.pmlsound.com/anthem/avm90/videos/AnthemDealerLocatorAnimation_19.mp4"
          type="video/mp4"
        />
      </video>
    </section>
  );
};

export default Locator;
